module.exports = __webpack_public_path__ + "static/media/04-0202.78b0c6af.png";